import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../Sections/CheckinEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../../Sections/EstablishmentChoiceEntry";
import MaintenanceWorkflowForwardingFinancialReviewEntrySection from "../../../Sections/FinancialReviewEntry";

const ExecutionEntryOnGoingFinancialReview = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingFinancialReviewEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection
        manualEntryProps={{
          showProposalDiagnostic: true,
        }}
      />
    </>
  );
}

export default ExecutionEntryOnGoingFinancialReview;
